<template>
  <div class="common-page order-management">
    <div class="top-box">
      <!--      <div class="tab-box">-->
      <!--        <custom-tab-box-->
      <!--          :tabData="tabData"-->
      <!--          @change="handleChangeTab"-->
      <!--          :selectTab="selectTab"-->
      <!--        ></custom-tab-box>-->
      <!--      </div>-->
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="下单时间:">
                <custom-date-range
                  :start-date="searchForm.orderTimeStart"
                  :end-date="searchForm.orderTimeEnd"
                  @update:startDate="(val) => (searchForm.orderTimeStart = val)"
                  @update:endDate="(val) => (searchForm.orderTimeEnd = val)"></custom-date-range>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单来源:">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.orderFrom"
                  filterable
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in $dict.orderFromOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单类型:">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.orderSource"
                  filterable
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in $dict.orderSourceOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单编号:">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="searchForm.orderNo"
                  autocomplete="off"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="销售归属:">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.sellerCompanyId"
                  filterable
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in companyData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="承运机构:">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.receptCompanyId"
                  filterable
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in companyData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="装货地:">
                <custom-city-cascader
                  :province-code="searchForm.loadProvinceCode"
                  :city-code="searchForm.loadCityCode"
                  :district-code="searchForm.loadDistrictCode"
                  @update:provinceCode="
                    (val) => (searchForm.loadProvinceCode = val)
                  "
                  @update:cityCode="(val) => (searchForm.loadCityCode = val)"
                  @update:districtCode="
                    (val) => (searchForm.loadDistrictCode = val)
                  "></custom-city-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="卸货地:">
                <custom-city-cascader
                  :province-code="searchForm.unloadProvinceCode"
                  :city-code="searchForm.unloadCityCode"
                  :district-code="searchForm.unloadDistrictCode"
                  @update:provinceCode="
                    (val) => (searchForm.unloadProvinceCode = val)
                  "
                  @update:cityCode="(val) => (searchForm.unloadCityCode = val)"
                  @update:districtCode="
                    (val) => (searchForm.unloadDistrictCode = val)
                  "></custom-city-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单状态:" prop="orderStatus">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.orderStatus"
                  filterable
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in $dict.orderStatusOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
                <el-button type="primary" @click="handleDownload()" :loading="downloadLoading">导出</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <div class="statistics-box">
        <div class="statistics-list">
          <div class="statistics-num">
            <div class="num color52C41A">{{ detailData.totalNum }}</div>
            <div class="txt">订单总量</div>
          </div>
        </div>
        <div class="statistics-list">
          <div class="statistics-num">
            <div class="num">{{ detailData.unDispatchNum }}</div>
            <div class="txt">待派单订单数</div>
          </div>
        </div>
        <div class="statistics-list">
          <div class="statistics-num">
            <div class="num">{{ detailData.doingNum }}</div>
            <div class="txt">运输中订单数</div>
          </div>
        </div>
        <div class="statistics-list">
          <div class="statistics-num">
            <div class="num">{{ detailData.completeNum }}</div>
            <div class="txt">已完成订单数</div>
          </div>
        </div>
        <div class="statistics-list">
          <div class="statistics-num">
            <div class="num">{{ detailData.completeRatio }}</div>
            <div class="txt">履约率</div>
          </div>
        </div>
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:orderSource="{ row }">
          {{ getLocalLabel("orderSource", row.orderSource) }}
        </template>
        <template v-slot:orderFrom="{ row }">
          <!--            {{ getLocalLabel("orderFrom", row.orderFrom) }}-->
          <div class="sty100" v-if="row.orderFrom === 11">三方系统推送</div>
          <div class="sty10" v-if="row.orderFrom === 12">三方补仓订单</div>
          <div class="sty10" v-if="row.orderFrom === 1">小程序下单</div>
          <div class="sty20" v-if="row.orderFrom === 2">客服代下单</div>
        </template>
        <template v-slot:startCityName="{ row }">{{ row.startCityName }}{{ row.startDistrictName }}</template>
        <template v-slot:fee="{ row }">{{ row.fee || "-" }}元</template>
        <template v-slot:endCityName="{ row }">{{ row.endCityName }}{{ row.endDistrictName }}</template>
        <template v-slot:orderStatus="{ row }">
          <span class="common-status status-cancel" v-if="row.orderStatus === 0">已取消</span>
          <span class="common-status status-confirm" v-if="row.orderStatus === 100">已完成</span>
          <span class="common-status status-pending-order" v-if="row.orderStatus === 1">待支付</span>
          <span class="common-status status-confirm" v-if="row.orderStatus === 10">待派单</span>
          <span class="common-status status-in-progress" v-if="row.orderStatus === 20">运输中</span>
        </template>
        <template v-slot:operation="{ row }">
          <span class="operate-btn" @click="openDetail(row)">详情</span>
        </template>
      </custom-table>
    </div>

    <detail ref="detail"></detail>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import { downloadTable, getOverview, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import detail from "./detail.vue";
import CustomCityCascader from "@/components/CustomCityCascader.vue";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import { getLocalLabel } from "@/utils/localDict";
export default {
  name: "ShipperManagement",
  mixins: [tableMixin],
  components: {
    CustomTabBox,
    CustomCityCascader,
    OperateBox,
    CustomTable,
    detail,
    CustomDateRange,
  },
  data() {
    return {
      getTableMethod: getPage,
      downloadFileMethod: downloadTable,
      haveCompany: true,
      searchForm: {
        sellerCompanyId: "",
        receptCompanyId: "",
        loadProvinceCode: "",
        loadCityCode: "",
        loadDistrictCode: "",
        orderFrom: "",
        orderNo: "",
        orderSource: "",
        orderStatus: "",
        orderTimeStart: "",
        orderTimeEnd: "",
        unloadProvinceCode: "",
        unloadCityCode: "",
        unloadDistrictCode: "",
      },
      detailData: {},
      tabData: [
        {
          label: 1,
          value: "平台订单",
        },
        {
          label: 2,
          value: "三方订单",
        },
      ],
      selectTab: 1,
      deptList: [],

      isImmediatelyGetData: true,
      tableColumn: [
        {
          label: "订单编号",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "订单类型",
          prop: "orderSource",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "订单来源",
          prop: "orderFrom",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "销售归属",
          prop: "sellerCompanyName",
          align: "left",
          show: true,
        },
        {
          label: "承运机构",
          prop: "driverCompanyName",
          align: "left",
          show: true,
        },
        {
          label: "货物名称",
          prop: "cargoName",
          align: "left",
          show: true,
        },
        {
          label: "订单金额",
          prop: "fee",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "装货地",
          prop: "startCityName",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "卸货地",
          prop: "endCityName",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "订单状态",
          prop: "orderStatus",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "下单时间",
          prop: "createTime",
          align: "left",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "100px",
          scopeStatus: true,
          show: true,
        },
      ],
      statisticsImage1: require("@/assets/imgs/huozhuzongliang.png"),
      statisticsImage2: require("@/assets/imgs/youxiaohuozhu.png"),
      statisticsImage3: require("@/assets/imgs/xiadanbishu.png"),
      statisticsImage4: require("@/assets/imgs/dingdanwancheng.png"),
      statisticsImage5: require("@/assets/imgs/leijijine.png"),
    };
  },
  created() {
    this.getTongJi();
  },
  mounted() {},
  methods: {
    getLocalLabel,
    handleCheck() {
      this.getTableData();
      this.getTongJi();
    },
    handleReset() {
      this.searchForm = this.$options.data.call(this).searchForm;
      this.tableOptions.currentPage = 1;
      this.getTableData();
      this.getTongJi();
    },
    getTongJi() {
      getOverview(this.searchForm).then((res) => {
        if (res.code === 200) {
          this.detailData = res.data;
        }
      });
    },
    handleChangeTab(val) {
      this.selectTab = val;
    },
    openDetail(row) {
      this.$refs.detail.init(row);
    },
  },
};
</script>
<style lang="scss" scoped>
.order-management {
  .top-box {
    .tab-box {
      padding: 0.2rem 0 0 0.2rem;
    }
  }
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }

  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
  .statistics-box {
    display: flex;
    justify-content: space-around;
    padding: 0 0.16rem;
    margin: 0 -0.1rem;
    .statistics-list {
      width: 33.33%;
      height: 1.2rem;
      background-color: #ffffff;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.2rem;
      box-sizing: border-box;
      margin: 0 0.1rem;
      .statistics-image {
        width: 0.8rem;
        height: 0.61rem;
      }
      .statistics-num {
        .num {
          font-size: 0.24rem;
          color: #000000;
          font-weight: bold;
          text-align: center;
        }

        .txt {
          font-size: 0.14rem;
          color: #434343;
          padding-top: 0.1rem;
          text-align: center;
        }
      }
    }
  }
}
</style>
